import React, {useState} from 'react';
import TransitionExpand from './TransitionExpand';
import CompletedCourseDetails from './CompletedCourseDetails';
import _ from 'lodash';
import classes from './index.css';
import { div } from 'prelude-ls';

export default function CompletedCourseBody(props){
    // console.log('completed course body props');
    // console.log(props);

    const[savedChildData, setSavedChildData] = useState({});

    const toggleActivityRollup = () => {
        //no clue :\
    }
    const saveChildData = (stuff, key) => {
        var datas = _.cloneDeep(savedChildData);
        datas[key] = stuff;
        if(!_.isEqual(savedChildData, datas)) setSavedChildData(datas);
    }


    return(
        <div
            className={classes.coursesBox + ' ' + classes.fullwidth}>
            <h2>Completed Courses</h2>
            <div
                className={classes.buttonRow}>
                {Object.keys(props.courses).map((courseId, kee) => {
                    var course = props.courses[courseId];
                    var isHidden = course.hidden ? classes.btnNotPressed : classes.btnPressed;
                    return(
                        <div 
                            key={kee}
                            className={classes.chironCompletedCourse + ' ' + classes.btnLvl2 + ' ' + isHidden}
                            onClick={() => {props.toggleHide(course.id)}}>
                            <h3>{course.name}</h3>
                        </div>
                    )
                })}
            </div>
            <div className={classes.fullFlex}>
                {Object.keys(props.courses).map((courseId, kee) => {
                    var course = props.courses[courseId];
                    return(
                        <TransitionExpand key={kee}
                            duration={500} height={!course.hidden ? 'auto' : 0}>
                            {!course.hidden &&
                            (
                                <CompletedCourseDetails
                                    courseid={course.id}
                                    coursename={course.name}
                                    compidlist={course.competencies}
                                    fullcomplist={props.fullcomplist}
                                    course={course}
                                    activityshowlist={props.activityshowlist[course.id]}
                                    showActivities={props.showActivities[course.id]}
                                    showCompetencies={props.showCompetencies[course.id]}
                                    showCompActivities={props.showCompActivities[course.id]}
                                    showKSAT={props.showKSAT[course.id]}
                                    showGrades={props.showGrades[course.id]}
                                    toggleRollup={props.toggleHideActivityRollup}
                                    setActivityCompShowList={props.setActivityCompShowList}
                                    toggleShowActivities={()=>{props.toggleShowActivities(course.id)}}
                                    toggleShowCompetencies={()=>{props.toggleShowCompetencies(course.id)}}
                                    toggleShowTasks={()=>{props.toggleShowKsat(course.id, 'T')}}
                                    toggleShowKnowledge={()=>{props.toggleShowKsat(course.id, 'K')}}
                                    toggleShowCompActivities={props.toggleShowCompActivities}
                                    toggleShowSkill={()=>{props.toggleShowKsat(course.id, 'S')}}
                                    toggleShowAbility={()=>{props.toggleShowKsat(course.id, 'A')}}
                                    toggleShowGrades={()=>{props.toggleShowGrades(course.id)}}
                                    //@save-please="saveChildData($event, `course${course.id}`)"
                                    //:parentSaved="savedChildData[`course${course.id}`]"
                                />
                            )}
                        </TransitionExpand>
                    )
                })}
            </div>
        </div>
    )
}